<template>
  <UICard title="Ownership">
    <UICheckbox
      v-model="lookThrough"
      label="Show ownership percentage adjusted values"
    />
  </UICard>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useSettingsStore } from '@/store/settings'

import { UICard } from '@ui/core'
import { UICheckbox } from '@ui/controllers'

const settingsStore = useSettingsStore()

const lookThrough = computed<boolean>({
  get() {
    return settingsStore.getOwnershipAdjustedValues
  },
  set(value) {
    settingsStore.setOwnershipAdjustedValues(value)
  },
})
</script>
